import { getCompany } from "./accel/company";
import { authenticate } from "./accel/authenticate";
import { getTransactions, getTransactionsMonth } from "./accel/transactions";
import { getProfitAndLoss, getRevenueProfitExpense, getProfitAndLossYearly } from "./accel/profit&loss";
import { getPlaidLink, putPlaidAccounts, getPlaidTransactions} from "./accel/plaid";
import { getAccounts } from "./accel/accounts";
import { getCategories } from "./accel/category";
import {
  getChats,
  createChat,
  getChatMessages,
  sendMessage,
  promptByCompany,
} from "./accel/chat";
import {
  editTransaction,
  reconcileTransactions,
  incomeStatement,
  transactionReport,
  classifyTransactions,
} from "./accel/transactions";
import { getIncomeStatementSheet, getIncomeStatementPDF } from "./accel/reports";
export const Accel = {
  getCompany,
  authenticate,
  getTransactions,
  getTransactionsMonth,
  getProfitAndLoss,
  getProfitAndLossYearly,
  getRevenueProfitExpense,
  classifyTransactions,
  getPlaidLink,
  putPlaidAccounts,
  getAccounts,
  getCategories,
  getChats,
  createChat,
  getChatMessages,
  sendMessage,
  promptByCompany,
  editTransaction,
  reconcileTransactions,
  incomeStatement,
  transactionReport,
  getIncomeStatementSheet,
  getIncomeStatementPDF,
  getPlaidTransactions,
};

// Add type annotation to Accel
export type AccelType = typeof Accel;
